import { PENDING_STATUS } from "./types";

export const pendingResponse = (isPending) => ({
  type: PENDING_STATUS,
  isPending,
});
